export default __webpack_public_path__ + "static/media/EyeOutlineIcon.13b0123e.svg";